module.exports = __webpack_public_path__ + "img/marker-icon-2x-blue-waves.c6ec0593.png";